class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);

    document.body.classList.remove('show-product-form')
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  // 8080 multi product form
  renderContents(parsedState) {
    if(parsedState.hasOwnProperty('items')) {
      // multiple products

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = document.getElementById(section.id)
        if(sectionElement && parsedState.sections[section.id]) {
          sectionElement.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            (section.selectors) ? parsedState.items.map(item => `[id="cart-notification-product-${item.key}"]`) : undefined
          );
        }
      });

    } else {
      // one product
      this.cartItemKey = parsedState.key;

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = document.getElementById(section.id)
        if (sectionElement && parsedState.sections[section.id]) {
          sectionElement.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selectors
          );
        }
      });

    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-overlay',
        selector: '#cart-overlay'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-notification-product',
        // 8080 removed to be able to add more than 1 product
        // fix so that we see only currently added ones
        selectors: [`[id="cart-notification-product-${this.cartItemKey}"]`],
      }
    ];
  }


  getSectionInnerHTML(html, selectors = ['.shopify-section']) {

    let elementHTML = ''

    selectors.forEach(selector => {
      elementHTML += new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
    })

    return elementHTML
  }


  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);